/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualVersion: core.serialization.ObjectSchema<serializers.EqualVersion.Raw, Truvity.EqualVersion> =
    core.serialization.object({
        value: core.serialization.number(),
    });

export declare namespace EqualVersion {
    export interface Raw {
        value: number;
    }
}
